import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import LandingPage from "./components/landingPage";
import MehndiPage from "./components/mehndiPage";
import MakeupPage from "./components/makeupPage";
import Footer from "./components/footer";
import { Analytics } from "@vercel/analytics/react";
import Navbar from "./components/Navbar";
import LegalAndFAQ from "./components/Legal";
import ScrollToTop from "./components/ScrollToTop";
import { preloadGalleryImages } from "./utils/preloadGalleryImages";

import "./App.css";

const PAGE_EASE = [0.65, 0, 0.35, 1];

const PageTransition = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
    transition={{ duration: 0.38, ease: PAGE_EASE }}
  >
    {children}
  </motion.div>
);

function AppContent() {
  const location = useLocation();
  const [isShrunk, setIsShrunk] = useState(location.pathname !== "/");

  useEffect(() => {
    if (location.pathname !== "/") {
      setIsShrunk(true);
      return;
    }

    setIsShrunk(window.scrollY > 50);
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname !== "/") {
      return undefined;
    }

    const onScroll = () => {
      setIsShrunk((prev) => {
        if (prev) {
          return true;
        }
        return window.scrollY > 50;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [location.pathname]);

  const handleRevealClick = () => {
    if (location.pathname !== "/") {
      return;
    }

    if (isShrunk) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        setIsShrunk(false); // expand
      }, 500);
    } else {
      setIsShrunk(true); // shrink immediately
    }
  };

  return (
    <>
      <Navbar isHomeShrunk={isShrunk} onRevealClick={handleRevealClick} />
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <PageTransition>
                <LandingPage />
              </PageTransition>
            }
          />
          <Route
            path="/mehndi"
            element={
              <PageTransition>
                <MehndiPage />
              </PageTransition>
            }
          />
          <Route
            path="/hair&beauty"
            element={
              <PageTransition>
                <MakeupPage />
              </PageTransition>
            }
          />
          <Route
            path="/legal"
            element={
              <PageTransition>
                <LegalAndFAQ />
              </PageTransition>
            }
          />
        </Routes>
      </AnimatePresence>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    preloadGalleryImages();
  }, []);

  return (
    <Router>
      <Analytics />
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
